import { SupportContextProvider, UIContextProvider } from "@/stores";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { FC } from "react";
import { LayoutProps, Layout as ReactAdminLayout } from "react-admin";
import { AppBarPanel } from "../../app-bar-panel/index.ts";
import { Modal } from "../../modal/index.ts";
import { Sidebar } from "../../sidebar/index.ts";
import { CustomRoutesMenu } from "./custom-routes-menu.component.tsx";

const GlobalLayout: FC<LayoutProps> = ({ children }) => {
  return (
    <UIContextProvider>
      <SupportContextProvider>
        <ReactAdminLayout
          appBar={AppBarPanel}
          sidebar={Sidebar}
          menu={CustomRoutesMenu}
        >
          {children}
          <ReactQueryDevtools initialIsOpen />
        </ReactAdminLayout>

        <Modal />
      </SupportContextProvider>
    </UIContextProvider>
  );
};

export { GlobalLayout };
